<script lang="ts" setup>
import Checkbox from '~/components/form-elements/Checkbox.vue'
import LabelText from '~/components/form-elements/LabelText.vue'
import type { CheckboxChoice } from '~/types/form-elements'

const model = defineModel<any>()

withDefaults(
  defineProps<{
    choices: CheckboxChoice[]
    isVertical?: boolean
    labelText?: string | null
    name: string
  }>(),
  { isVertical: false, labelText: null }
)

const emit = defineEmits<{
  (e: 'onCheckboxChanged', event: any): void
}>()

function onCheckboxChanged (event: any): void {
  emit('onCheckboxChanged', event)
}
</script>

<template>
  <div>
    <LabelText class="mb-2" :value="labelText" />

    <div
      class="-mx-3 -my-1 flex"
      :class="{ 'flex-wrap items-center': !isVertical, 'flex-col items-start': isVertical }"
    >
      <Checkbox
        v-for="x in choices"
        :key="String(x.value)"
        v-model="model"
        class="mx-3 my-1"
        :input-value="x.value"
        :is-order-tag="x.isOrderTag"
        :is-status="x.isStatus"
        :label-text="x.labelText"
        :name="name"
        :order-tag-color="x.orderTagColor"
        :status-color="x.statusColor"
        @on-checkbox-changed="onCheckboxChanged"
      />
    </div>
  </div>
</template>
